/* The Bon Pet - homepage scroll animations.
 * Reveals + staggered cascades via one IntersectionObserver, gentle image
 * parallax via rAF. Pairs with bonpet-scroll.css + the inline html.tbp-anim
 * gate in bonpet-v3-head.liquid. Accessible: bails on reduced motion; if this
 * never runs, the CSS hidden state is never applied, so content shows normally.
 */
(function () {
  'use strict';

  // Respect reduced-motion (the inline gate already skipped html.tbp-anim, but
  // double-check so we never run observers / parallax either).
  var reduce = false;
  try { reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches; } catch (e) {}
  if (reduce || !document.documentElement.classList.contains('tbp-anim')) return;

  // Selectors must mirror bonpet-scroll.css.
  var REVEAL = [
    '.tbp-prod-grid .tbp-pg-eyebrow', '.tbp-prod-grid .tbp-pg-heading',
    '.tbp-prod-grid .tbp-pg-sub', '.tbp-prod-grid .tbp-pg-controls',
    '.tbp-hiw-eyebrow', '.tbp-hiw-heading', '.tbp-hiw-sub',
    '.tbp-transparency-head', '.tbp-transparency-card', '.tbp-founder-content',
    '.tbp-delivery-promise-section .tbp-container', '.tbp-sku-content', '.tbp-sku-media',
    '.tbp-vol-banner-card', '.tbp-reviews-head', '.tbp-reviews-carousel', '.tbp-trial-heading',
    '.tbp-community h2', '.tbp-community-sub', '.tbp-community-ctas',
    '.tbp-faqx-head', '.tbp-final-cta h2', '[data-reveal]'
  ];
  var STAGGER = [
    '.tbp-reassurance-grid', '.tbp-prod-grid .tbp-products', '.tbp-hiw-grid',
    '.tbp-sku-list', '.tbp-vol-banner-bullets', '.tbp-trial-grid',
    '.tbp-final-grid', '.tbp-faqx-list', '[data-reveal-stagger]'
  ];

  function collect(list) {
    var out = [];
    list.forEach(function (sel) {
      var nodes = document.querySelectorAll(sel);
      for (var i = 0; i < nodes.length; i++) {
        if (out.indexOf(nodes[i]) === -1) out.push(nodes[i]);
      }
    });
    return out;
  }

  var targets = collect(REVEAL.concat(STAGGER));

  function revealAll() {
    targets.forEach(function (el) { el.classList.add('tbp-is-in'); });
  }

  if (!('IntersectionObserver' in window) || !targets.length) {
    revealAll();
  } else {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('tbp-is-in');
          io.unobserve(entry.target); // fire once
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
    targets.forEach(function (el) { io.observe(el); });

    // Safety sweep: after load, reveal only targets already in/above the
    // viewport (catches observer misses) - below-fold targets stay observed so
    // they still animate in as you scroll to them.
    window.setTimeout(function () {
      var vh = window.innerHeight || document.documentElement.clientHeight;
      targets.forEach(function (el) {
        if (el.classList.contains('tbp-is-in')) return;
        if (el.getBoundingClientRect().top < vh) {
          el.classList.add('tbp-is-in');
          io.unobserve(el);
        }
      });
    }, 1200);
  }

  /* ===== Gentle parallax on the founder + recipe-pack images ===== */
  var parallaxEls = [];
  ['.tbp-founder-media img', '.tbp-transparency-pack img'].forEach(function (sel) {
    var n = document.querySelector(sel);
    if (n) parallaxEls.push(n);
  });

  if (parallaxEls.length) {
    var ticking = false;
    var enabled = window.innerWidth >= 768;

    function frame() {
      ticking = false;
      var vh = window.innerHeight;
      parallaxEls.forEach(function (el) {
        if (!enabled) { el.style.transform = 'scale(1.05)'; return; }
        var r = el.getBoundingClientRect();
        if (r.bottom < 0 || r.top > vh) return; // off-screen, skip
        var offset = (r.top + r.height / 2) - vh / 2;
        var y = Math.max(-16, Math.min(16, offset * -0.045));
        el.style.transform = 'translate3d(0,' + y.toFixed(1) + 'px,0) scale(1.05)';
      });
    }
    function onScroll() {
      if (!ticking) { ticking = true; window.requestAnimationFrame(frame); }
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', function () {
      enabled = window.innerWidth >= 768;
      onScroll();
    });
    frame();
  }
})();
